// JavaScript files are compiled and minified during the build process to the assets/built folder. See available scripts in the package.json file.

// Import CSS
import "../css/index.css";

// Import JS
import menuOpen from "./menuOpen";
import infiniteScroll from "./infiniteScroll";


// Call the menu and infinite scroll functions
menuOpen();
infiniteScroll();



document.addEventListener('DOMContentLoaded', function() {

    const header = document.getElementById('gh-head');
    let lastScrollTop = 0;
    let isScrolled = false;
    
    // 스크롤 임계값 증가
    const scrollDownThreshold = 100;  // 아래로 스크롤: 100px
    const scrollUpThreshold = 50;     // 위로 스크롤: 50px (더 빠르게 복원)
    
    function handleScroll() {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        
        // 스크롤 방향 확인
        const isScrollingDown = scrollTop > lastScrollTop;
        
        if (isScrollingDown) {
            // 아래로 스크롤: 100px 넘으면 축소
            if (scrollTop > scrollDownThreshold && !isScrolled) {
                header.classList.add('scrolled');
                isScrolled = true;
            }
        } else {
            // 위로 스크롤: 50px 아래로 내려가면 복원
            if (scrollTop < scrollUpThreshold && isScrolled) {
                header.classList.remove('scrolled');
                isScrolled = false;
            }
        }
        
        lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
    }
    
    // Passive 이벤트 리스너로 성능 개선
    window.addEventListener('scroll', handleScroll, { passive: true });
    
    // 초기 체크
    handleScroll();

    // document.querySelectorAll('.sub-menu-item').forEach(item => {
    //     const url = item.getAttribute('data-url').replace(/\/$/, '');
    //     const parentUrl = item.getAttribute('data-parent-url').replace(/\/$/, '');
        
    //     // 하이픈을 슬래시로 변환 후 매칭
    //     const convertedUrl = url.replace(/-/g, '/');
        
    //     if (!convertedUrl.startsWith(parentUrl + '/') || convertedUrl === parentUrl) {
    //         item.remove();
    //     }
    // });
    
    // // 빈 sub-menu 제거
    // document.querySelectorAll('.sub-menu').forEach(menu => {
    //     if (menu.children.length === 0) {
    //         menu.remove();
    //     }
    // });
    

    document.querySelectorAll('.main-menu').forEach(function(menu) {
        const label = menu.dataset.label;
        const prefix = '[' + label + '] ';
        const submenu = menu.querySelector('.sub-menu');
        const items = submenu.querySelectorAll('.sub-menu-item');

        // Label 접두사 제거
        items.forEach(function(item) {
            const link = item.querySelector('a');
            link.textContent = link.textContent.replace(prefix, '');
        });
        
        // 빈 서브 메뉴 숨김
        if (items.length === 0) {
            submenu.style.display = 'none';
            menu.classList.add('no-submenu');
        }
    });
    
    
    const scrollButton = document.getElementById('scroll-to-top');
    
    if (!scrollButton) return;
    
    // 스크롤 이벤트 리스너 (300px 이상 스크롤 시 버튼 표시)
    function toggleScrollButton() {
        if (window.pageYOffset > 300) {
            scrollButton.classList.add('visible');
        } else {
            scrollButton.classList.remove('visible');
        }
    }
    
    // 버튼 클릭 시 맨 위로 스크롤
    scrollButton.addEventListener('click', function() {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    });
    
    // 키보드 접근성 (Enter 또는 Space 키)
    scrollButton.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        }
    });

    // 다크모드 토글
    const themeToggle = document.getElementById('theme-toggle');
    if (themeToggle) {
        themeToggle.addEventListener('click', function() {
            const isDark = document.documentElement.getAttribute('data-theme') === 'dark';
            if (isDark) {
                document.documentElement.removeAttribute('data-theme');
                localStorage.setItem('theme', 'light');
            } else {
                document.documentElement.setAttribute('data-theme', 'dark');
                localStorage.setItem('theme', 'dark');
            }
        });
    }
});